import React, { Component } from 'react';
import { connect } from 'react-redux';

import { Grid, Row, Col } from '../../components/GridSystem';
import PortfolioItem from '../../components/PortfolioItem';

import { fetchPortfolio } from '../../modules/home';

class PortfolioSection extends Component {
    componentDidMount() {
        const { dispatch, isPortfolioLoaded } = this.props;        

        // Only load this once
        if (!isPortfolioLoaded) {
            dispatch(fetchPortfolio({
                per_page: 5,
            }));
        }
    }

    renderOnBoarding() {
        return [1,2,3,4,5].map((item) => {
            const lg = item === 1 ? 8 : 4;
            return (
                <Col xs={12} md={6} lg={lg} className="portfolio-item item-loading" key={item}>
                    <span className="portfolio-item__link item-loading__inner">
                        <span className="portfolio-item__inner layer-cover layer-cover-bg">
                        </span>
                    </span>
                    <span className="highlight"></span>
                </Col>
            )
        });
    }

    renderPortfolio() {
        const { portfolio } = this.props;

        return portfolio.map((data, index) => (
            <PortfolioItem key={index} data={data} index={index} />
        ));
    }

    render() {
        const { isLoadingPortfolio } = this.props;

        return (
            <div className="portfolio-section block-section">
                <Grid>
                    <h2 className="block-section__title portfolio-section__title">
                        <span>Featured</span> <span>Works</span>
                    </h2>

                    <Row className="portfolio-list">
                        { 
                            isLoadingPortfolio ? 
                            this.renderOnBoarding() :
                            this.renderPortfolio()
                        }

                        <Col xs={12} md={6} lg={4} className="portfolio-item portfolio-archive-item">
                            <a className="portfolio-archive-item__link portfolio-item__link">
                                <div className="portfolio-archive-item__inner portfolio-item__inner layer-cover">
                                    <div className="portfolio-archive-item__text">
                                        See All <br/>
                                        Works →
                                    </div>
                                </div>
                            </a>
                        </Col>
				
                    </Row>
                </Grid>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    const { 
        isLoadingPortfolio, 
        isPortfolioLoaded,
        portfolio,
    } = state.home;

    return {
        isLoadingPortfolio,
        isPortfolioLoaded,
        portfolio,
    };
}

export default connect(mapStateToProps)(PortfolioSection);


// WEBPACK FOOTER //
// ./src/containers/Home/PortfolioSection.js